import { ClipboardList, Sparkles } from "lucide-react";
import { Card } from "./QuadroBase";
import type { QuadroProps } from "./tipos";

const TEXTOS = {
  tratamentos: {
    titulo: "Tratamentos em andamento",
    icone: ClipboardList,
    tom: "emerald" as const,
    texto: "Os planos de tratamento ativos do paciente vão aparecer aqui.",
  },
  alertas: {
    titulo: "Alertas clínicos",
    icone: Sparkles,
    tom: "amber" as const,
    texto: "Alergias, medicações em uso e avisos relevantes vão aparecer aqui.",
  },
};

/** Quadros de funções que ainda não existem — ocupam o lugar e dizem o que vem. */
export function QuadroEmBreve({ tipo, menu }: Pick<QuadroProps, "menu"> & { tipo: keyof typeof TEXTOS }) {
  const { titulo, icone: Icone, tom, texto } = TEXTOS[tipo];
  return (
    <Card icon={<Icone className="h-4 w-4" />} title={titulo} tone={tom} menu={menu}>
      <div className="flex flex-col items-center gap-2 py-8 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-zinc-100 dark:bg-muted">
          <Icone className="h-6 w-6 text-zinc-400" />
        </div>
        <span className="rounded-full bg-zinc-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-zinc-500 dark:bg-muted dark:text-muted-foreground">
          Em breve
        </span>
        <p className="max-w-xs text-xs text-zinc-500 dark:text-muted-foreground">{texto}</p>
      </div>
    </Card>
  );
}
